// extracted by mini-css-extract-plugin
export default {"errorTop":"Error_errorTop__VWiN0"};